import React, { useState } from "react";
import Translator from "Languages/Utility/Translator";
import { useDispatch, useSelector } from "react-redux";
import { push } from "Helpers/History";
import { signInUser } from "Stores/actions";
import Input from "Components/Input/Input";
import showNotify from "Helpers/Notify";
import AuthHeader from "../components/AuthHeader";
import MuiButton from "Components/MuiButton/MuiButton";
// import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useSetState } from "Helpers/Hooks";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";

// function SignIn(props) {
function SignIn() {
  const { t } = useTranslation();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { cwt } = useSelector((state) => ({
    cwt: state.settings.cwt,
  }));
  const [controls, setControls] = useSetState({
    userName: {
      value: "",
      validation: {
        required: true,
      },
    },
    password: {
      value: "",
      validation: {
        required: true,
        minLength: 6,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid({
      ...formValid,
      [name]: validation,
    });
  };

  const onSignUP = () => {
    if (cwt.update && cwt.Active && cwt?.IsShowRegister) push("/auth/signup");
  };

  const onForgetPassWord = () => {
    if (cwt.update && cwt.Active) push("/auth/forgetPassword");
  };

  const onUserLogin = async (e) => {
    e.preventDefault();
    if (cwt && cwt.Active) {
      const { userName, password } = controls;
      if (
        userName.value !== "" &&
        password.value !== "" &&
        Object.values(formValid).every((item) => item === true)
      ) {
        try {
          setLoading(true);
          const token = ""; // await props.googleReCaptchaProps?.executeRecaptcha();
          const data = {
            UserName: userName.value,
            Password: password.value,
            keyCap: token,
          };
          await dispatch(signInUser(data));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      } else {
        showNotify({
          text: t("checkAllFields"),
          customClass: "warning",
        });
      }
    }
  };

  return (
    <div className="signIn">
      <AuthHeader
        title={t("header_welcome")}
        description={t("header_enter_your_information_to_enter_the_panel")}
      />
      <p className="header-custom">{t("login_text_custom")}</p>
      <form onSubmit={onUserLogin}>
        <div className="mt-4">
          <Input
            setValue={setValue.bind(this)}
            name="userName"
            value={controls.userName.value}
            validation={controls.userName.validation}
            label={<Translator id="input_userName" />}
            icon={<Icons.Person />}
            type="text"
            fullWidth
          />
        </div>
        <div className="mt-2">
          <Input
            setValue={setValue.bind(this)}
            name="password"
            value={controls.password.value}
            validation={controls.password.validation}
            label={<Translator id="input_password" />}
            icon={<Icons.ShieldLock />}
            type="password"
            fullWidth
          />
        </div>
        <div className="mt-3 d-flex justify-content-center">
          <MuiButton
            loading={loading}
            color="primary"
            type="submit"
            className="w-100"
            title={<Translator id="button_login" />}
          />
        </div>
        <div className="d-flex justify-content-center">
          <MuiButton
            color="secondary"
            type="submit"
            onClick={onSignUP}
            className="w-100 mt-2 mb-3"
            title={<Translator id="button_signup" />}
            disabled={cwt.update && cwt.Active && !cwt?.IsShowRegister}
            hidden={cwt.update && cwt.Active && !cwt?.IsShowRegister}
          />
        </div>
        <div className="d-flex justify-content-center ">
          <MuiButton
            className="link"
            onClick={onForgetPassWord}
            title={<Translator id="button_forgot_password" />}
          />
        </div>
        {cwt.update && cwt.Active && cwt?.IsShowContact && (
          <div className="border-top pt-1 text-center">
            <p className="link-text">
              {t("needSupport")}
              <a
                href="https://fdpco.ir/contact/"
                target="_blank"
                className="mx-1"
                style={{ fontWeight: "350" }}
              >
                {t("fdpSupport")}
              </a>
            </p>
          </div>
        )}
      </form>
    </div>
  );
}

export default SignIn;
// export default withGoogleReCaptcha(SignIn);
